import React from 'react';
import { GripVerticalIcon } from 'lucide-react';

interface DragHandleProps {
  attributes: Record<string, any>;
  listeners: Record<string, any> | undefined;
}

export const DragHandle: React.FC<DragHandleProps> = ({ attributes, listeners }) => {
  return (
    <button
      {...attributes}
      {...listeners}
      className="cursor-grab active:cursor-grabbing p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors touch-none"
      tabIndex={-1}
    >
      <GripVerticalIcon className="h-4 w-4 text-gray-400" />
    </button>
  );
};
